import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FileService } from 'src/app/services/file.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-slider-home',
  templateUrl: './slider-images.component.html',
  styleUrls: ['./slider-images.component.scss'],
})
export class SliderHomeComponent implements OnInit {
  @Input() imagesUploaded: any[] = [];
  @Input() edit;
  @Input() type;
  @Input() typeSlider;
  @Input() ocultInput = false;
  @Input() homeParams;
  @Input() domainId;
  @Input() imagesId;
  @Input() editing;
  @Input() selectedBanner;
  @Input() beforeSelected;
  @Input() previousUploaded;
  @Input() orden;
  @Input() uriFile: string = 'banner';
  @Input() destroyRoute: string = 'destroyImage';
  @ViewChild('imagesInput') imagesInput: ElementRef<HTMLInputElement>;
  @Output() deleteImage = new EventEmitter();
  @Output() emitId = new EventEmitter();

  public typeImage = '';
  public indexImage: number | null = null;
  public isSending = false;
  public defaultImg = environment.defaultImg;
  public urlBanner = '';

  constructor(
    private fileSv: FileService,
    private httpSv: HttpService,
    private uiSv: UiServices
  ) {}

  ngOnInit() {
    this.urlBanner = environment[this.uriFile];
  }

  async destroyImage(url, file, id, typeImage?: string) {
    try {
      if (url?.includes('data:image')) {
        this.removeImage(url, null, null, typeImage);
        return true;
      }
      // await this.httpSv.deleteImageProduct();
      this.removeImage(url, file, id, typeImage);
    } catch (err) {
      console.error(err);
    }
  }

  async uploadImage(event) {
    try {
      await this.uiSv.showLoading();
      const file = (<HTMLInputElement>event.target).files[0];
      const image = this.imagesUploaded[this.indexImage];
      await this.fileSv.uploadFile(
        this.type,
        file,
        image,
        this.typeImage,
        event
      );
      await this.uiSv.loading.dismiss();
      return;
    } catch (err) {
      console.error(err);
    }
  }

  async removeImage(url, file?, id?, typeImage?: string) {
    // this.deleteImage.emit(url);
    let body: any = {
      file,
      id,
    };
    for (const image of this.imagesUploaded) {
      if (image.file === file || image.smallFile === file) {
        if (typeImage === 'mobile') {
          body.smallFile = file;
          image.urlSmall = null;
          image.smallFile = null;
          delete body.file;
        } else {
          image.url = null;
          image.file = null;
        }
        break;
      }
    }
    if (id) {
      await this.fileSv.destroyImg(body, this.uriFile);
    }
  }

  addOtherBanner() {
    this.imagesUploaded.push({
      title: '',
      description: '',
      file: null,
      url: null,
      urlSmall: null,
      smallFile: null,
    });
  }

  async saveHomeParams() {
    try {
      if (this.homeParams) {
        const body: any = {
          name: 'headerParams',
          type: 'json',
          value: JSON.stringify(this.homeParams),
          domainId: this.domainId,
        };
        this.editing && (body.id = this.editing);
        const res: any = await this.httpSv.itemAction(
          body,
          'parameter',
          this.editing ? 'update' : 'store'
        );
        this.editing = res.data.id;
      }

      if (this.selectedBanner !== this.beforeSelected) {
        this.previousUploaded.map((item) => {
          const body = {
            file: item.file,
            id: item.id,
          };
          this.fileSv.destroyImg(body, 'banner');
        });
      }

      if (this.imagesUploaded.length) {
        this.uploadMainSlider();
      }
    } catch (err) {
      console.error(err);
    }
  }

  async uploadMainSlider() {
    try {
      const resImage: any = await this.fileSv.postImage(
        this.selectedBanner || this.type,
        this.domainId,
        this.imagesId,
        this.imagesUploaded,
        this.type,
        0,
        this.orden
      );
      this.imagesUploaded = resImage.data.images;
      this.imagesUploaded.map(
        (item) => (item.url = `${this.urlBanner}${item.file}`)
      );
      this.imagesId = resImage.data.id;
    } catch (err) {
      console.error(err);
    }
  }

  addImage(type, index: number) {
    this.typeImage = type;
    this.indexImage = index;
    this.imagesInput.nativeElement.click();
  }

  async removeSlider(id, index) {
    try {
      const { role } = await this.uiSv.presentAlert(
        '¿Desea eliminar este slider?'
      );
      if (role === 'accept') {
        await this.httpSv.itemAction({ id }, this.uriFile, this.destroyRoute);

        this.imagesUploaded.splice(index, 1);
      }
    } catch (err) {
      console.error(err);
    }
  }
}
